/**
 * @type {object}
 */
const userRoles = {
  CREATOR: 'creator',
  REVIEWER: 'reviewer'
}

export { userRoles }
